import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  container: {
    marginHorizontal: 10,
    paddingTop: 14,
    paddingBottom: 9,
    // borderBottomWidth: 1,
    // borderBottomColor: PALETTE.primaryStrokeLine,
  },
});
